import script from "./Hero-Simple-Centered.vue?vue&type=script&setup=true&lang=js"
export * from "./Hero-Simple-Centered.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__